import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

 constructor(private ws: PostmethodService) { }

  getReportsList() {
    return this.ws.wsGet(environment.loginUrl + "/reports/ho-reports-list");
  }

  generateReport(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/reports/ho-generate-report");
  }
}